import { memo } from 'react';

import PhotoModelCloseUpField from './components/photoModelField/components/photoModelCloseUpField/photoModelCloseUpField';
import PhotoModelFullField from './components/photoModelField/components/photoModelFullField/photoModelFullField';
import PhotoModelHalfField from './components/photoModelField/components/photoModelHalfField/photoModelHalfField';
import CampaignFormField, {
  CampaignFormFieldProps,
} from '../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import OtherRequestsField from '../../../../formFields/otherRequestsField/otherRequestsField';

type PhotoModelFieldsProps = Pick<CampaignFormFieldProps, 'label' | 'description'>;

const PhotoModelFields = ({ label, description }: PhotoModelFieldsProps) => {
  return (
    <CampaignFormField
      as="div"
      wrapperClassName="pb-[50px] border-b border-[#E8E8E8]"
      label={label}
      description={description}
    >
      {/* 제품 착용샷 */}
      <ul className="flex flex-col gap-4">
        {/* 제품 착용샷 - 정면 풀샷 */}
        <PhotoModelFullField />
        {/* 제품 착용샷 - 반신샷 */}
        <PhotoModelHalfField />
        {/* 제품 착용샷 - 제품 디테일 클로즈업 */}
        <PhotoModelCloseUpField />
      </ul>

      {/* 기타 전달 사항 */}
      <OtherRequestsField />
    </CampaignFormField>
  );
};

export default memo(PhotoModelFields);
